import styled from 'styled-components';
import { StyledToolTipProps } from './ToolTip.types';

export const StyledToolTip = styled.div<StyledToolTipProps>`
  position: relative;
  display: inline-block;

  ${(props) => props.customStyle}
`;
